import axios, {HttpStatusCode} from "axios";

export const retrieveHistory = async (username, limit, gameVariant) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/history/list/${username}?limit=${limit}&gameVariant=${gameVariant}`)
    if(response.status !== HttpStatusCode.Ok) {
        throw new Error("Cannot retrieve history, error returned: " + response.status)
    }

    return await response.data;
}

export const retrieveStatistics = async (username, gameVariant) => {
    return (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/history/stats/${username}?gameVariant=${gameVariant}`)).data
}


export const getHistoryForGameId = async (gameId) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/history/${gameId}`, {withCredentials: true})

    return await response.data
}



